import Vue from "vue"
import Vuex from 'vuex'

// 1.安装插件
Vue.use(Vuex)

// 2.创建对象
const store = new Vuex.Store({
    state:{
        commonParameters: {},

        baseColor: "#D32723",// 红包中心的基本色
        baseSecondColor: "#EB473E",// 红包中心背景色渐变的第二个颜色
        rebateTypeBgColor: "#FF6760",// 瓜分红包，等级红包标题的背景色
        exchangeSelectedStartColor: "#FF9063",// 兑换选择额度的选项选中状态颜色值之一
        exchangeSelectedEndColor: "#FF3948",// 兑换选择额度的选项选中状态颜色值之一
        openRebateUI1: false,// 是不是需要替换成RebateUI1的红包资源
        
        titleFontSize:"1.125rem",// 18px
        inputFontSize:"0.75rem",// 12px
        buttonSize:"0.75rem",// 12px

        payPageTitleColor:"#5A5A5A",

        // 显示微信绑定授权二维码界面，因为在多个页面都可能显示，就放在最外层，可随时打开
        showWxBindPage: false,
        qrCodeUrl: "",
        // 显示加载中动画
        showLoading: false,
        // 显示提示窗口
        showAlert: false,
        alertMessage: "提示窗口文字",
        
        // 显示toast
        showToast: false,
        toastMessage: "toast文字",

        // 未读消息条数
        unreadMessages: 0,

        rid: "",
        phone: "",

        showChangePassword: false, //显示修改密码页面
        showRebateTypeMoney: false, //显示红包类型提现页面

        // 红包初始化返回
        initData: {
            content: "",// 活动规则文案
            money: "0",// 活动可领取的总金额，单位元
            download: "",// 分享的下载链接
            rebateType: [],// 红包类型，数组类型的json字符串，里面包含 typeid 红包列ID、typename 红包名称、typesort 红包排序、typetype 红包类型
            holidayMember: "",// 参加活动人数
            receiveTotal: "",// 已发放总金额
            bonusPool: "",// 奖金池总金额
            giftstatus: "",// 礼包状态，1：开启，0：关闭
        },
        // 红包用户接口返回
        userInfoData:{
            moneysum: "0",// 活动用户总领取金额，单位元
            aliuser: "0",// 是否绑定支付宝，1：是，0：否
            wxuser: "0",// 是否绑定微信，1：是，0：否
            mobile: "0",// 是否绑定手机，1：是，0：否
            timeout: "0",// 活动倒计时，单位：秒  \
            dayconsecutive:"",// 连续登录天数，单位：天
            daycount: "", // 累计登录天数，单位：天
            rolereg: "",// 创角时间
        },
        // 角色数据
        roleInfoData:{
            roleId: "",
            roleName: "",
            serverId: "",
            serverName: "",
            level: ""
        },
        rebateTypeMoneyList:[],
        bagList:[],
        ruleContent: "",//红包规则，除了抢红包的
        v3AlertMessageSize: "x-small",
        // onActivityResume: false,//android的onResume
    },
    mutations:{
        // 接收客户端传来的数据，并将角色数据赋值给 roleInfoData 
        updateCommonParams(state, payload){
            // console.log(payload)
            state.commonParameters = JSON.parse(payload)
            state.roleInfoData.roleId = state.commonParameters["roleid"];
            state.roleInfoData.roleName = state.commonParameters["rolename"];
            state.roleInfoData.serverId = state.commonParameters["serverid"];
            state.roleInfoData.serverName = state.commonParameters["servername"];
            state.roleInfoData.level = state.commonParameters["rolelevel"];
            // Vue.set(state.commonParameters, JSON.parse(payload))
        },
        UpdateRidAndPhone(state, payload){
            state.commonParameters["rid"] = payload["rid"];
            state.commonParameters["phone"] = payload["phone"];
            state.rid = payload["rid"];
            state.phone = payload["phone"];
        },
        // 网络请求到红包初始化数据之后重新赋值
        updateInitData(state,payload){
            // console.log("红包初始化")
            // console.log(payload)
            state.initData = payload
            // console.log("红包初始化后获得的 rebateType");
            // console.log(state.initData['rebateType']);
            state.initData['rebateType'] = JSON.parse(state.initData['rebateType']);
        },
        // 网络请求到红包用户信息数据之后重新赋值
        updateRebateUserInfoData(state,payload){
            // console.log("红包用户信息")
            // console.log(payload)
            state.userInfoData = payload
        },
        //用户信息接口，根据用户名去获取phone,rid值的
        updateInfoData(state,payload){
            // console.log("用户信息")
            // console.log(payload)
            state.commonParameters['rid'] = payload['rid']
            state.commonParameters['phone'] = payload['phone']
        },
        // 改变微信绑定二维码界面显示状态
        showWxBindPageState(state, showOrHide){
            state.showWxBindPage = showOrHide;
        },
        // 切换加载中动画
        switchLoading(state, showOrHide){
            state.showLoading = showOrHide;
        },
        // 切换提示窗口
        switchAlert(state, payload){
            state.showAlert = payload["showOrHide"];
            state.alertMessage = payload["alertMessage"];
        },
        // 切换toast
        switchToast(state, payload){
            state.showToast = payload["showOrHide"];
            state.toastMessage = payload["toastMessage"];
        },
        // 兑换成功之后，总金额
        updateMoneySum(state, payload){
            // state.userInfoData.moneysum = payload["money"];
            state.userInfoData.moneysum = payload["moneysum"];
        },
        // 更新未读信息
        updateUnreadMessages(state, payload){
            state.unreadMessages = payload;
        },
        // onActivityResume(state, payload){
        //     state.onActivityResume = true;
        // },
        // 修改要显示的Qrcode
        changeQrcodeUrl(state, payload){
            state.qrCodeUrl = payload;
        },
        //领取完红包之后，更新对应的红包数据，以及所有页面需要显示的数据更新
        updateBonusPoolAndMoneySum(state, payload){
            // 领取完直接在领取的页面中重新获取数据，不在这里刷新
            // 更新奖金池
            state.initData.bonusPool = payload["bonuspool"];
            state.userInfoData.moneysum = payload["moneysum"];
        },
        // 更新红包中心的背景色
        updateBaseColorAndSecondColor(state, payload){
            state.baseColor = payload['baseColor'];
            state.baseSecondColor = payload['baseSecondColor'];
        },
        // 是否开启的是 RebateUI1 的红包资源
        updateRebateUI1Open(state, payload){
            state.openRebateUI1 = payload;
            state.rebateTypeBgColor = "#FF5273";
            state.exchangeSelectedStartColor = "#FF849C"// 兑换选择额度的选项选中状态颜色值之一
            state.exchangeSelectedEndColor = "#FF5273"// 兑换选择额度的选项选中状态颜色值之一
        },
        // 更新登录界面的宽高
        updateLoginPageSize(state, payload){
            state.payCenterPageWidth = "45vw";
            state.payCenterPageHeight = "55vh";
        },
        // 更新登录界面的宽高
        updateLoginPageSizeWithValue(state, payload){
            if (payload['screenWidth']) {
                state.payCenterPageWidth = payload['screenWidth'];
            }
            if (payload['screenHeight']) {
                state.payCenterPageHeight = payload['screenHeight'];
            }
        },
        // 更新修改密码页面显示状态
        updateChangePasswordShowState(state, payload){
            state.showChangePassword = payload
        },
        // 更新红包类型提现页面显示状态
        updateRebateTypeMoneyShowState(state, payload){
            state.showRebateTypeMoney = payload
        },
        updateRebateTypeMoneyList(state,payload){
            state.rebateTypeMoneyList = payload
        },
        updateBagList(state, payload){
            state.bagList = payload
        },
        updateRuleContent(state, payload){
            state.ruleContent = payload
        },
        updateAlertMessageSize(state, payload){
            state.v3AlertMessageSize = payload
        },
        
    },
    actions:{
        // 获取rid和phone后，更新到基本参数中
        networkUpdateRid(context, payload){
            context.commit('UpdateRidAndPhone', payload);
        } ,
        // 异步获取红包初始化，用户信息后，更新数据
        networkHandleRebateAndUserInit(context, payload){
            context.commit('updateInitData', payload.initData);
            context.commit('updateRebateUserInfoData', payload.userInfoData);
        },
        // 异步领取红包之后，去更新数据
        networkLevelRebateRecevice(context, payload){
            context.commit('updateMoneySum', payload);
        },
        // 兑换之后，去更新数据
        networkExchange(context, payload){
            context.commit('updateMoneySum', payload);
        },
        // 网络请求后，需要隐藏微信绑定二维码显示页面
        networkWxBindPageShow(context, payload){
            context.commit("changeQrcodeUrl", payload['qrcodeUrl']);
            context.commit("showWxBindPageState", payload['showOrHide']);
        },
        // 红包V2，领取红包之后，去更新数据
        networkRebateRecevice(context, payload){
            context.commit('updateBonusPoolAndMoneySum', payload);
        },
        // 兑换之后，去更新数据
        networkExchange(context, payload){
            context.commit('updateMoneySum', payload);
        },
        networkUpdateRebateTypeMoneyList(context, payload){
            context.commit('updateRebateTypeMoneyList', payload);
        },
        networkUpdateBagList(context, payload){
            context.commit('updateBagList', payload);
        },
    },
    getters:{
        
    },
    modules:{
        
    }
})

// 3.导出
export default store


// WEBPACK FOOTER //
// ./src/SdkV3/store/index.js